module.exports = __webpack_public_path__ + "static/scale-model-of-the-stephen-hopkins-house-in-providence-rhode-island-aea47692a959de975a8b2ac875059468.png";